import { ROUTES } from 'src/constants';
import { form, toastStore } from 'src/stores';

import { validate } from 'utils/core';
import { history } from 'utils/history';
import { t } from 'utils/t';

import { REGISTRATION_LINKS_FORM_ID } from '../constants';

import { mapFormToBE } from '../utils';

import { linksService } from '../services';

import { smartLinksFormValidation } from '../validations';

export const handleSubmitNew = async () => {
  const data = form.fetchWithoutObservable(REGISTRATION_LINKS_FORM_ID) as any;
  const withDiscount = Boolean(data.discount);

  const isValid = validate(REGISTRATION_LINKS_FORM_ID, data, smartLinksFormValidation(withDiscount) as any);
  if (!isValid) return;

  const mappedData = mapFormToBE(data);
  const isOk = await linksService.createMagicLink(mappedData);
  if (isOk) {
    toastStore.show(t.staticAsString('smartLinks.formCreated', { name: mappedData.name }));
    history.push(ROUTES.smartLinks);
  }
};

export const handleCancelForm = () => {
  history.goBack();
};
